// CONSTANTS are all caps.
const NS = 'ParkingDetailsHeroBlock';
const CLS = 'parkingDetailsHeroBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rParkingDetailsHeroBlock from './ParkingDetailsHeroBlock.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';
import * as Api from '../../../../global/js/api';

export class ParkingDetailsHeroBlock {
  constructor(el) {
    // $el is the blk node return by the loadParkingDetailsHeroBlock function
    this.$el = $(el);
    this.$openinghours = $('#parkingServiceBlock-openinghours');
    this.$accordion = $('#parkingServiceBlock-accordion');
    this.api = $(el).data('api');
    this.lat = $(el).data('lat');
    this.lng = $(el).data('lng');
    this.zoom = $(el).data('zoom');
    this.iconBookOnline = el.dataset.iconBookOnline;
    this.iconMonthlyParking = el.dataset.iconMonthlyParking;
    this.iconParkingCard = el.dataset.iconParkingCard;
    this.iconEvCharger = el.dataset.iconEvCharger;
    this.iconLabelBookOnline = el.dataset.iconLabelBookOnline || 'Book Online';
    this.iconLabelMonthlyParking =
      el.dataset.iconLabelMonthlyParking || 'Monthly Parking';
    this.iconLabelParkingCard =
      el.dataset.iconLabelParkingCard || 'Parking Card';
    this.iconLabelEvCharger = el.dataset.iconLabelEvCharger || 'EV Charging';
    this.submitButtonLabel = el.dataset.submitButtonLabel || 'Book Now';
  }

  init() {
    // this.loadGoogleMapsJs();
    this.setParkingDetailsHeroBlock();
    this.fetchData();
    // Attach event delegation for dynamically inserted elements
    document.body.addEventListener('click', (event) => {
      if (event.target && event.target.id === 'book-cta') {
        this.handleOpenPrepayModal(event);
      }
    });
  }

  fetchData() {
    Api.getApi(this.api).then((response) => {
      console.log(response);

      if (response && response.data && response.data.length >= 0) {
        console.log(response);
        this.showMap(response.data);
      } else {
        console.log('return response is null');
      }
    });
  }

  setParkingDetailsHeroBlock() {
    // Add Some logic here
    const $blk = $(this.$el);

    // to recalculate slick's slider width
    $blk.find('#parkingGallery').on('shown.bs.modal', () => {
      // not supported on all browsers
      $(window).trigger('resize');
      // preferred (native)
      if (typeof Event === 'function') {
        window.dispatchEvent(new Event('resize'));
      }
    });

    // this.$el.find('.parkingServiceBlock-accordion-anchor').on('click', () => {
    // 	this.scrollToAccordion();
    // });

    this.$el
      .find('.parkingServiceBlock-openinghours-anchor')
      .on('click', () => {
        let $target = $(`.parkingServiceBlock-openinghours`);
        let delta = 0;
        let deltaAttr = $('.siteHeader').attr('data-sticky');
        if (typeof deltaAttr !== 'undefined' && deltaAttr !== 'false') {
          delta = $('.siteHeader').height();
        }
        let offsetHeader = $target.offset().top - delta * 2 - 16;
        if ($target.length) {
          $('html, body').stop().animate(
            {
              scrollTop: offsetHeader,
            },
            1000
          );
        }
      });

    this.$el.find('.direction-btn').on('click', () => {
      // let newUrl = this.openGoogleMapUrl(this.lat, this.lng);
      // window.location.href = newUrl;
      // window.open(newUrl, '_blank');

      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $('.directionsBlock').offset().top,
          },
          1000
        );
    });

    this.$el
      .find(`.parkingDetailsHeroBlock-accordion-trigger`)
      .on('click', (e) => {
        this.triggerAcc(e.currentTarget.dataset.collapseId);
      });

    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const openingTime = {};
    $('#openingTimeList input:hidden').each((index, element) => {
      const _val = element.value.split('|');
      openingTime[_val[0]] = _val[1];
    });
    const currentDay = daysOfWeek[new Date().getDay()];
    this.$el.find('.opening-time').html(openingTime[currentDay]);
  }

  triggerAcc(collapseId) {
    if (collapseId && collapseId.length > 0) {
      $(`#${collapseId}`).addClass('show');
      let $headingEl = $(`#${collapseId}`).siblings();
      let delta = 0;
      let deltaAttr = $('.siteHeader').attr('data-sticky');
      if (typeof deltaAttr !== 'undefined' && deltaAttr !== 'false') {
        delta = $('.siteHeader').height();
      }
      let offsetHeader = $headingEl.offset().top - delta * 2 - 16;
      if ($headingEl.length) {
        $('html, body').stop().animate(
          {
            scrollTop: offsetHeader,
          },
          1000
        );
      }
    }
  }

  showMap(data) {
    console.log(data);

    const $blk = $(this.$el);
    const This = this;
    let lat = $blk.data('lat');
    let lng = $blk.data('lng');
    let mapCenter = new google.maps.LatLng(lat, lng);

    let map = new google.maps.Map(document.getElementById('map-holder'), {
      center: mapCenter,
      zoom: this.zoom,
      disableDefaultUI: true,
      gestureHandling: 'greedy',
      clickableIcons: false,
    });
    let bounds = new google.maps.LatLngBounds();

    // map center location
    let centerMarker = new google.maps.Marker({
      position: mapCenter,
      icon: {
        url: $blk.find('.map-red-icon').attr('src'),
        scaledSize: new google.maps.Size(36, 48),
      },
      map: map,
    });
    bounds.extend(mapCenter);

    let redIcon = {
      url: $blk.find('.map-red-icon').attr('src'),
      scaledSize: new google.maps.Size(25, 33),
    };

    let purpleIcon = {
      url: $blk.find('.map-purple-icon').attr('src'),
      scaledSize: new google.maps.Size(25, 33),
    };

    let surroundingIcon = {
      url: '/assets/images/map/pin.png',
      scaledSize: new google.maps.Size(25, 33),
    };

    let infowindow = new google.maps.InfoWindow({
      // content: contentString,
    });

    data.map((e, i) => {
      let position = new google.maps.LatLng(e.lat, e.lng);
      bounds.extend(position);

      if (e.externalCarParkInfo) {
        surroundingIcon.url = e.externalCarParkInfo.pinUrl;
      } else {
        surroundingIcon.url = '/assets/images/map/pin.png';
      }

      let _marker = new google.maps.Marker({
        position: position,
        icon: surroundingIcon,
        map: map,
      });

      _marker.addListener('click', () => {
        let contentString = this.renderWindow(e);
        infowindow.setContent(contentString);
        infowindow.open(map, _marker);
      });
    });

    // console.log(map);
    // to cover all markers
    // map.fitBounds(bounds);
  }

  // Add more functions like on above here
  openGoogleMapUrl(lat, lng) {
    return `https://maps.google.com/?q=${lat},${lng}`;
  }

  renderWindow(e) {
    // const isElevateOnly = e.carParkFeature.includes('Elevate Only');

	const isElevateOnly = () => {
		const prepayCarParkFeature = window.prepayCarParkFeature; // E.g: 'Epark,Elevate Only,Prepay Online'
		if (!e.carParkFeature || !prepayCarParkFeature || e.carParkFeature.length === 0) return;
		const prepayFeaturesArray = prepayCarParkFeature.split(',');
		return prepayFeaturesArray.every((feature) => e.carParkFeature.includes(feature));
	};

    let googleMapUrl = this.openGoogleMapUrl(e.lat, e.lng);
    const iconBookOnline = this.iconBookOnline
      ? `style="background-image:url(${this.iconBookOnline})"`
      : '';
    const iconMonthlyParking = this.iconMonthlyParking
      ? `style="background-image:url(${this.iconMonthlyParking})"`
      : '';
    const iconParkingCard = this.iconParkingCard
      ? `style="background-image:url(${this.iconParkingCard})"`
      : '';
    const iconEvCharger = this.iconEvCharger
      ? `style="background-image:url(${this.iconEvCharger})"`
      : '';
    let contentString = `
		<div class="infoWindow">
			<div class="text-torch-red font-weight-bold fsp-16">${e.carParkName}</div>
			<div class="fsp-14 lh-2">${e.address}</div>
			${
        e.distance === null
          ? ''
          : `<div class="fsp-14 lh-2 text-mine-shaft">${e.distance}km direct</div>`
      }
			${
        e.price === null || e.price <= 0
          ? ''
          : `<div class="fsp-14 lh-3">From <span class="font-weight-bold">$${e.price}</span></div>`
      }
			<div class="option-wrap mt-3 mb-4">
				${
          e.services.includes('book a bay')
            ? `<div class="text-center d-inline-block mr-3">
						<div class="option-icon book-online mb-1" ${iconBookOnline}></div>
						<div class="fsp-12">${this.iconLabelBookOnline}</div>
					</div>`
            : ``
        }

				${
          e.services.includes('monthly')
            ? `<div class="text-center d-inline-block mr-3">
						<div class="option-icon monthly-parking mb-1" ${iconMonthlyParking}></div>
						<div class="fsp-12">${this.iconLabelMonthlyParking}</div>
					</div>`
            : ``
        }

				${
          e.services.includes('wilson one')
            ? `<div class="text-center d-inline-block mr-3">
						<div class="option-icon wilson-one mb-1" ${iconParkingCard}></div>
						<div class="fsp-12">${this.iconLabelParkingCard}</div>
					</div>`
            : ``
        }

				${
          e.services.includes('ev charging')
            ? `<div class="text-center d-inline-block mr-0">
						<div class="option-icon ev-charger mb-1" ${iconEvCharger}></div>
						<div class="fsp-12">${this.iconLabelEvCharger}</div>
					</div>`
            : ``
        }
			</div>
			<div class="d-flex align-items-center justify-content-center text-center cta-wrapper">
				${
          e.bookUrl
            ? `<a id="book-cta" target="${
                isElevateOnly() ? '_self' : '_blank'
              }" data-elevate-only="${isElevateOnly()}" href="${
                isElevateOnly() ? 'javascript:void(0)' : e.bookUrl
              }" class="btn btn-primary fsp-14 flex-1">${
                this.submitButtonLabel
              }</a>`
            : ``
        }
				${
          e.detailUrl
            ? `<a href="${e.detailUrl}" class="fsp-14 flex-1">View details</a>`
            : ``
        }
				<a href="${googleMapUrl}" target="_blank" class="fsp-14 flex-1">Get directions</a>
			</div>
		</div>
		`;
    return contentString;
  }

  handleOpenPrepayModal(event) {
    const isElevateOnly = event.target.dataset.elevateOnly === 'true';
    if (!isElevateOnly) return;

    const prepayModal = document.getElementById('prepayModal');
    if (prepayModal && prepayModal.classList.contains('hidden')) {
      prepayModal.classList.remove('hidden');
    }
  }
}
